import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Container from "./Container";
import {useCookies} from "react-cookie";
import {Link} from "gatsby";
import {useLocation} from "@reach/router" // this helps tracking the location
import {initializeAndTrack} from 'gatsby-plugin-gdpr-cookies'

const Holder = styled.div`
  position: fixed;
  z-index: 101;
  bottom: 1rem;
  left: 0;
  width: 100%;
`;
const Inner = styled.div`
  width: 100%;
  color: ${props => props.theme.colours.green};
  background-color: ${props => props.theme.colours.white};
  padding: 1rem;
  border-radius: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  @media ( ${props => props.theme.breakpoints.sm} ) {
    padding: 1rem 2rem;
    grid-template-columns: 2fr 1fr;
    align-items: center;
  }
  @media ( ${props => props.theme.breakpoints.md} ) {
    border-radius: 5000px;
  }

  p {
    margin: 0;
    font-size: 13px;
  }

  .buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media ( ${props => props.theme.breakpoints.sm} ) {
      justify-content: flex-end;
    }

    button, a {
      margin: 0 0.5rem 0 0;
      @media ( ${props => props.theme.breakpoints.sm} ) {
        margin: 0 0 0 1rem;
      }
    }
  }
`;

function CookieConsentPopup() {
  const [show, setShow] = useState(false)
  const [cookies, setCookie] = useCookies([
    'gatsby-gdpr-google-analytics',
    'gatsby-gdpr-facebook-pixel',
    'gatsby-gdpr-linkedin',
  ]);
  const location = useLocation()

  const handleAccept = () => {
    setCookie('gatsby-gdpr-google-analytics', true)
    setCookie('gatsby-gdpr-facebook-pixel', true)
    setCookie('gatsby-gdpr-linkedin', true)
    initializeAndTrack(location)
  }

  const handleDeny = () => {
    setCookie('gatsby-gdpr-google-analytics', false)
    setCookie('gatsby-gdpr-facebook-pixel', false)
    setCookie('gatsby-gdpr-linkedin', false)
  }

  useEffect(() => {
    if(
      cookies['gatsby-gdpr-google-analytics'] &&
      cookies['gatsby-gdpr-facebook-pixel'] &&
      cookies['gatsby-gdpr-linkedin']
    ) {
      setShow(false)
    } else {
      setShow(true)
    }
  }, [cookies]);

  if (!show) return null;

  return (
    <Holder>
      <Container>
        <Inner>
          <div className="text">
            <p>We’ve updated our Privacy Policy. Our website uses cookies to
              detect and resolve website problems, assist with customer support,
              improve customer experience, and allow permissions and access
              rights to users. We will not collect any personally identifiable
              information about site visitors in this process.</p>
          </div>
          <div className="buttons">
            <Link to="/privacy" onClick={() => handleDeny()}>Learn more</Link>
            <button className="green" onClick={() => handleAccept()}>Accept</button>
          </div>
        </Inner>
      </Container>
    </Holder>
  )
}

export default CookieConsentPopup;